import React from 'react';

function TextAlignRight({ size }) {
  return (
    <svg height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.9999 6H3V7.49999H20.9999V6Z" fill="black" />
      <path d="M20.9999 9.75H9V11.25H20.9999V9.75Z" fill="black" />
      <path d="M20.9999 17.25H9V18.75H20.9999V17.25Z" fill="black" />
      <path d="M20.9999 13.5H3V15H20.9999V13.5Z" fill="black" />
    </svg>
  );
}

export default TextAlignRight;
